import { normalize, Schema, arrayOf } from 'normalizr'

import store from '@store/store.ts'
import { receiveEntities } from '@actions/entity_actions.js'
import { receiveCategories } from '@actions/category_actions.js'
import { receiveCurrentUser, receiveUsers } from '@actions/user_actions.js'
import { receiveGroup, receiveGroups } from '@actions/group_actions.js'
import { receiveTags } from '@actions/tag_actions.js'
import { receiveComments } from '@actions/comment_actions.js'
import { loadJSONFromDOMNode } from './dom_node_data_loader.ts'
import { normalizeAndRemapTimeline } from './entities.js'
import { arrayToKeyedObject } from './object.js'
import { decodeAllStrings } from './decoder.ts'

// DOM Node data hydrators

// hydrates from the default node containing the current user
export function hydrateCurrentUser() {
  hydrateCurrentUserFromDOMNode('current-user-data')
}

export function hydrateCurrentUserFromDOMNode(dataDOMId) {
  const parsedJSON = loadJSONFromDOMNode(dataDOMId)
  if (parsedJSON && parsedJSON.hasOwnProperty('current_user')) {
    store.dispatch(receiveCurrentUser(parsedJSON.current_user))
  } else {
    console.warn('Failed to hydrate current user')
  }
}

export function hydrateUsersFromDOMNode(dataDOMId) {
  const parsedJSON = loadJSONFromDOMNode(dataDOMId)
  const users = arrayToKeyedObject(parsedJSON)
  store.dispatch(receiveUsers(users))
}

export function hydrateGroupFromDOMNode(dataDOMId) {
  const parsedJSON = loadJSONFromDOMNode(dataDOMId)
  store.dispatch(receiveGroup(parsedJSON))
}

export function hydrateGroupsFromDOMNode(dataDOMId) {
  const parsedJSON = loadJSONFromDOMNode(dataDOMId)
  const groupsMap = arrayToKeyedObject(parsedJSON)
  store.dispatch(receiveGroups(groupsMap))
}

export function hydrateCommentsFromDOMNode(dataDOMId) {
  const parsed = loadJSONFromDOMNode(dataDOMId)

  // comments comes in as an array, so create an object that normalizr can deal with easily
  const normalizableObj = {
    comments: parsed,
  }

  const comment = new Schema('comments')
  const user = new Schema('users')
  comment.define({
    user,
  })
  const normalized = normalize(normalizableObj, {
    comments: arrayOf(comment),
    users: arrayOf(user),
  })

  // first put the users into state, then the comments
  store.dispatch(receiveUsers(normalized.entities.users))
  store.dispatch(receiveComments(normalized.entities.comments))
}

export function hydrateCompleteTimelineFromDOMNode(dataDOMId) {
  const parsedJSON = loadJSONFromDOMNode(dataDOMId)
  const normalized = normalizeAndRemapTimeline(parsedJSON)
  store.dispatch(receiveEntities(normalized.entities))
}

// JSON hydrators

export function hydrateCategoriesFromJSON(encodedJSON) {
  const decoded = decodeAllStrings(encodedJSON)
  const parsedJSON = JSON.parse(decoded)

  // categories comes as an array, so normalize it first
  const categorySchema = new Schema('categories')
  const normalized = normalize(parsedJSON, arrayOf(categorySchema))
  store.dispatch(receiveCategories(normalized.entities.categories))
}

export function hydrateTagsFromDOMNode(dataDOMId) {
  const parsedJSON = loadJSONFromDOMNode(dataDOMId)
  store.dispatch(receiveTags(parsedJSON))
}
